import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import React, { useEffect, useState } from 'react'
import { getCurrentDate } from 'utils/todayDateForInput'
import styles from './TaskDeadline.module.scss'
function TaskDeadline({
  setIsAllowChange,
  setisSkipDayOff,
  setIsCheckFinish,
  setIsDeterm,
  setDeadlineDate,
  showChecks,
}) {
  const { t } = useTranslation('common')

  const [isShown, setIsShown] = useState(false)
  const [date, setDate] = useState(null)
  const [Checked1, setChecked1] = useState(false)
  const [Checked2, setChecked2] = useState(false)
  const [Checked3, setChecked3] = useState(false)
  const [Checked4, setChecked4] = useState(false)
  const handleClick = (event) => {
    setIsShown((current) => !current)
  }
  // FIX: parent setters must run AFTER render, not during it.
  useEffect(() => {
    setDeadlineDate(date)
  }, [date, setDeadlineDate])
  useEffect(() => {
    setIsAllowChange(Checked1)
  }, [Checked1, setIsAllowChange])
  useEffect(() => {
    setisSkipDayOff(Checked2)
  }, [Checked2, setisSkipDayOff])
  useEffect(() => {
    setIsCheckFinish(Checked3)
  }, [Checked3, setIsCheckFinish])
  useEffect(() => {
    setIsDeterm(Checked4)
  }, [Checked4, setIsDeterm])
  return (
    <div className={styles.task_deadline}>
      <div className={styles.deadline_heading}>
        <p>{t('taskInfo.th_deadline')}</p>
        <input
          type="date"
          className={cx(styles.task_whitespace, styles.deadline)}
          onChange={(e) => setDate(e.target.value)}
          min={getCurrentDate()}
        />
        {showChecks === false ? (
          ''
        ) : (
          <span
            className={styles.task_link}
            style={{ borderBottom: '1px dotted grey' }}
            onClick={handleClick}
          >
            {t('auto.taskdeadline_taskdeadline.k1')}
          </span>
        )}
      </div>

      {isShown && (
        <div className={styles.deadline_checkboxes}>
          <div className={styles.checkbox}>
            <input
              id="important"
              type="checkbox"
              value={Checked1}
              onChange={() => setChecked1(!Checked1)}
            />
            <span>{t('auto.taskdeadline_taskdeadline.k2')}</span>
          </div>

          <div className={styles.checkbox}>
            <input
              id="important"
              name="title"
              type="checkbox"
              className={styles.title_input_check}
              value={Checked4}
              onChange={() => setChecked4(!Checked4)}
            />
            <span>{t('auto.taskdeadline_taskdeadline.k3')}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default React.memo(TaskDeadline)
